import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import bgImg from '../Images/book-appointment.webp'
import Breadcrumb from "../Components/Breadcrumb";
import { treatments, treatmentsGandhidham } from "../Data";
import { blogs } from "../Blog";

const Sitemap=()=>{

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const linkVariant = {
  hidden: {
    opacity: 0,
    x: -15,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
    },
  },
};

useEffect(() => {
                document.title =
                  "Sitemap | Dr. Jigar Gor Ayurvedic Clinic";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Explore all pages of Dr. Jigar Gor Ayurveda Clinic, including treatments, blogs, contact details, and Prakruti Analysis."
                  );
                }
            
              const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://msayurved.com/sitemap");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Sitemap | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Explore all pages of Dr. Jigar Gor Ayurveda Clinic, including treatments, blogs, contact details, and Prakruti Analysis."
                );
              }
            
             const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://msayurved.com/sitemap");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/home.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Sitemap | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Explore all pages of Dr. Jigar Gor Ayurveda Clinic, including treatments, blogs, contact details, and Prakruti Analysis."
                );
              }
            
               const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/home.webp"
                );
              }
              }, []);

    return(
        <>
          {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Sitemap"
        bgImage={bgImg}
        />

       <motion.section
  className="sitemap-section container"
  variants={containerVariant}
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.15,
  }}
>
  <div className="sitemap-intro">

    <motion.p
      className="section-subheading"
      variants={fadeUp}
    >
      Quick Navigation
    </motion.p>

    <motion.h2
      className="section-heading"
      variants={fadeUp}
    >
      Sitemap
    </motion.h2>

    <motion.p
      className="section-text"
      variants={fadeUp}
    >
      Browse every page available on the Dr. Jigar Gor Ayurveda website and quickly access treatments, wellness services, blogs, and important information.
    </motion.p>

  </div>

  <motion.div
    className="sitemap-grid"
    variants={containerVariant}
  >

    {/* MAIN PAGES */}

    <motion.div
      className="sitemap-card"
      variants={cardVariant}
      whileHover={{
        y: -5,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      <h3 className="card-heading">
        Main Pages
      </h3>

      <motion.ul variants={containerVariant}>
        <motion.li variants={linkVariant}>
          <NavLink to="/">Home</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/about-us">About Us</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/prakruti-analysis">Prakruti Analysis</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/blogs">Blogs</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/testimonials">Testimonials</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/contact-us">Contact Us</NavLink>
        </motion.li>

        <motion.li variants={linkVariant}>
          <NavLink to="/book-appointment">Book Appointment</NavLink>
        </motion.li>
      </motion.ul>
    </motion.div>

    {/* TREATMENTS */}

    <motion.div
      className="sitemap-card"
      variants={cardVariant}
      whileHover={{
        y: -5,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      <h3 className="card-heading">
        Treatments
      </h3>

      <motion.ul variants={containerVariant}>
        {treatments.map((item, i) => (
          <motion.li
            key={i}
            variants={linkVariant}
          >
            <NavLink to={`/treatments/${item.slug}`}>
              {item.title}
            </NavLink>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>

    {/**TREATMENTS IN GANDHIDHAM */}

    <motion.div
      className="sitemap-card"
      variants={cardVariant}
      whileHover={{
        y: -5,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      <h3 className="card-heading">
        Treatments in Gandhidham
      </h3>

      <motion.ul variants={containerVariant}>
         <motion.li
            variants={linkVariant}
          >
            <NavLink to={`/treatments/gandhidham`}>Treatments</NavLink>
          </motion.li>
        {treatmentsGandhidham.map((item, i) => (
          <motion.li
            key={i}
            variants={linkVariant}
          >
            <NavLink to={`/treatments/gandhidham/${item.slug}`}>
              {item.title}
            </NavLink>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>

    {/* BLOGS */}

    <motion.div
      className="sitemap-card blog-sitemap-card"
      variants={cardVariant}
      whileHover={{
        y: -5,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      <h3 className="card-heading">
        Blogs
      </h3>

      <motion.ul variants={containerVariant}>
        {blogs.map((item, i) => (
          <motion.li
            key={i}
            variants={linkVariant}
          >
            <NavLink to={`/blog/${item.slug}`}>
              {item.title}
            </NavLink>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>

  </motion.div>
</motion.section>
        </>
    )
}
export default Sitemap;